module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6BAMAAAB6wkcOAAAAD1BMVEWeMDn////48PGlP0ecLDWpY2OWAAAAXklEQVR42u3NMQ0AIAADsFnAAhawgH9NWOBbIK2BBgAAAAAAAAAAAAAA+NtuymrKbMposl+y2+12u91ut9vtdrv9nt1ut9vt9jf22ZTVlN0UAAAAAAAAAAAAAADgawfohyP5dWZ5xwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/lv.png
// module id = 454
// module chunks = 0